module.exports = __webpack_public_path__ + "media/fgs-037-148.d1a45ded.mp3";